import { Button } from '../../components/Button';
import { Plus } from '../../icons';
import { brandColor } from '../../styles/brand-colors';
import { useTheme } from '../../theme';
import { SurfaceEmptyState } from '../SurfaceEmptyState';
import type { MaterialKindEmptyStateProps } from './DeckMaterials.types';
import { DECK_MATERIAL_ICONS } from './icons';

/**
 * The Notes / Maps surface of a deck that lists NO note (or no mind map) —
 * ONE state on web and the phone, so the two cannot drift apart again: the
 * kind's glyph on the brand token, the title, and either the create button
 * (someone who may change the deck's materials) or the line saying why there
 * is none (a read-only viewer).
 *
 * Nothing is created by arriving here — only the press. Labels arrive
 * pre-translated; the host decides who may create by passing `onCreate`.
 */
export function MaterialKindEmptyState({
  kind,
  title,
  description,
  createLabel,
  onCreate,
  testID,
  createTestID,
  className,
}: MaterialKindEmptyStateProps) {
  const { isDark } = useTheme();
  const Icon = DECK_MATERIAL_ICONS[kind];
  return (
    <SurfaceEmptyState
      testID={testID}
      className={className}
      artwork={<Icon size={40} color={brandColor('primary', '500', isDark)} />}
      title={title}
      description={description}
      action={
        onCreate && createLabel ? (
          <Button
            variant="primary"
            size="l"
            fullWidth
            leftIcon={Plus}
            testID={createTestID}
            onPress={onCreate}>
            {createLabel}
          </Button>
        ) : undefined
      }
    />
  );
}
(MaterialKindEmptyState as { displayName?: string }).displayName =
  'MaterialKindEmptyState';
